import React from 'react';
import Star from '@/icons/Star';

interface ClaimProfileBannerProps {
  onClaimClick: () => void;
}

const ClaimProfileBanner: React.FC<ClaimProfileBannerProps> = ({ onClaimClick }) => {
  return (
    <div className="claim-banner">
      <span className="claim-banner__icon">
        <Star width={20} height={20} />
      </span>
      <div className="claim-banner__body">
        <p className="claim-banner__title">Claim your profile in this family.</p>
        <p className="claim-banner__sub">
          Connect your account to a person in the tree so others can see your contributions.
        </p>
      </div>
      <button type="button" onClick={onClaimClick} className="btn btn--primary btn--sm">
        Claim profile
      </button>
    </div>
  );
};

export default ClaimProfileBanner;
